"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$set = void 0;
var addFields_1 = require("./addFields");
/**
 * Alias for $addFields.
 */
exports.$set = addFields_1.$addFields;
